import styled from "@emotion/styled";
import {
  contentIn,
  ENTER_EASE,
  fadeIn,
  iconIn,
  motionSafe,
  strokeDraw,
} from "src/motion";

export const ChoiceCardButton = styled.button<{
  $compact: boolean;
  $selected: boolean;
  $locked: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.space.space8};
  padding: 7px 15px;
  border: ${({ theme }) => theme.effects.line.border};
  border-radius: ${({ theme }) => theme.effects.rounding._8};
  background-color: ${({ theme, $selected }) =>
    $selected ? theme.colors.tone.sand : theme.colors.tone.white};
  color: ${({ theme }) => theme.colors.tone.black};
  font-weight: ${({ $selected }) => ($selected ? 600 : 400)};
  line-height: 24px;
  text-align: left;
  cursor: pointer;
  pointer-events: ${({ $locked }) => ($locked ? "none" : "auto")};
  transition: background-color 150ms ease-out;

  &:hover {
    background-color: ${({ theme }) => theme.colors.tone.sand};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ $compact }) => ($compact ? "7px 15px" : "15px")};
  }
`;

export const ChoiceCardIcon = styled.span`
  display: inline-flex;
  flex-shrink: 0;
`;

export const ChoiceCardSuccess = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space.space8};
  padding: ${({ theme }) => theme.space.space8}
    ${({ theme }) => theme.space.space16};
  border-radius: ${({ theme }) => theme.effects.rounding._8};
  background-color: ${({ theme }) => theme.colors.tone.sand};
  line-height: 24px;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme }) => theme.space.space16};
  }

  &[data-animate="true"] {
    ${motionSafe`${contentIn} 420ms ${ENTER_EASE} both,
          ${fadeIn} 320ms ease-out both`};

    svg {
      ${motionSafe`${iconIn} 520ms 60ms ${ENTER_EASE} both`};
    }

    [data-draw] {
      stroke-dasharray: 1;
    }

    [data-draw="ring"] {
      ${motionSafe`${strokeDraw} 520ms 80ms ${ENTER_EASE} both`};
    }

    [data-draw="tick"] {
      ${motionSafe`${strokeDraw} 340ms 320ms ${ENTER_EASE} both`};
    }
  }
`;
